import Graphic from "@arcgis/core/Graphic";
import Point from "@arcgis/core/geometry/Point";
import Polygon from "@arcgis/core/geometry/Polygon";
import { selectedSymbol } from "../../../services/genericMethoud/gisMethouds";
import { getPolygonCenterPoint } from "../../../services/genericMethoud/gisMethouds";
import { getNhcIntegrationByObjIdFunction } from "../../../services/API";
import { GetPointData } from "../../../services/API";
import { PointDataEnvelope } from "../../../services/models/PointDataResponse";
import { getBaladyAccessToken } from "../../../services/API/baladyService";

/**
 * Creates feature graphics from geometry data
 */
export function createFeatureGraphics(
  type: any,
  geometry: any,
  wiki: any,
  attr: any,
  symbolS: any
) {
  console.log("createFeatureGraphics ==>geometry", geometry);
  let fFeature: any;
  
  switch (type) {
    case "polygon":
      fFeature = new Polygon({
        rings: geometry,
        spatialReference: {
          wkid: wiki,
        },
      });
      break;
    case "point":
      fFeature = new Point({
        x: geometry.x,
        y: geometry.y,
        spatialReference: {
          wkid: wiki,
        },
      });
      break;
  }

  const fFeatureGraphic = new Graphic({
    geometry: fFeature,
    symbol: symbolS,
    attributes: attr,
  });
  return fFeatureGraphic;
}

/**
 * Zooms to a specific layer
 */
export const zoomToLayer = (type: any, geometry: any, wiki: any, ZoomLevel: any, graphicsLayer: any, MapViewData: any) => {
  graphicsLayer.removeAll();

  let fGetGraphic: any = createFeatureGraphics(
    type,
    geometry,
    wiki,
    "",
    selectedSymbol
  );
  graphicsLayer.add(fGetGraphic);

  if (ZoomLevel) {
    let opts = {
      duration: 5000,
    };
    MapViewData.goTo(
      {
        target: fGetGraphic,
        zoom: 17,
      },
      opts
    );
  } else {
    let gr: any = graphicsLayer.graphics;
    MapViewData.goTo(gr.items[0].geometry.extent.expand(2));
  }
};

/**
 * Gets property data from coordinates
 */
export const getPropertyDataFromCoordinates = async (longitude: number, latitude: number) => {
  try {
    const baladyToken = await getBaladyAccessToken();
    const pointDataEnvelope: PointDataEnvelope = (
      await GetPointData(
        baladyToken,
        longitude.toString(),
        latitude.toString()
      )
    ).data;
    const pointResult = pointDataEnvelope.data.result;
    
    if (pointResult) {
      let plot = pointResult;
      let parcel_Cod = pointResult.objectId;
      
      if (parcel_Cod) {
        // Get NHC integration data
        const nhcData = await getNhcIntegrationByObjIdFunction(parcel_Cod);
        
        return {
          plot,
          parcel_Cod,
          nhcData: nhcData?.data || []
        };
      }
    }
    
    return null;
  } catch (error) {
    console.error("Error getting property data:", error);
    throw error;
  }
};

/**
 * Creates favorite land feature
 */
export const createFavoriteLandFeature = async (
  property: any,
  parcel_Cod: string,
  city_Name: string,
  districts_Name: string,
  neighbourhood_Name: string,
  propertyNumber: string,
  pPointgraphic: any,
  F_FavoriteLand: any
) => {
  if (!property) return;

  let attributes = {
    ParcelCode: `${parcel_Cod}`,
    City_Name: city_Name,
    District_Name: districts_Name,
    Neighbourhood_Name: neighbourhood_Name,
    Land_Numbe: propertyNumber,
  };

  // Calculate centroid from polygon geometry
  const centroid = property?.geometry ? getPolygonCenterPoint(property.geometry as any) : null;
  const pointGeometry = new Point({
    x: centroid?.x || 0,
    y: centroid?.y || 0,
    spatialReference: property?.geometry?.spatialReference
  });
  
  const addFeature = new Graphic({
    geometry: pointGeometry,
    attributes: attributes,
  });

  console.log("addFeature", addFeature);

  return F_FavoriteLand.applyEdits({ addFeatures: [addFeature] });
};

/**
 * Changes flashlight feature
 */
export const changeFlashLightFeature = async (
  property: any,
  selectedFeature: any,
  currentSelectedFeature: any,
  F_Land_parcels: any
) => {
  if (!property || !selectedFeature || !selectedFeature.attributes) {
    console.warn("Invalid selectedFeature or missing attributes");
    return false;
  }

  let featureFalsh =
    selectedFeature?.attributes?.Feature_Ad == "null" ||
    selectedFeature?.attributes?.Feature_Ad == null ||
    selectedFeature?.attributes?.Feature_Ad == "" ||
    selectedFeature?.attributes?.Feature_Ad == "false"
      ? "true"
      : "false";

  console.log("selectedFeature", selectedFeature);
  console.log("currentSelectedFeature", currentSelectedFeature);

  let isHaveFlashLand = currentSelectedFeature.filter(
    (geLayer: any) => geLayer.graphic.attributes?.Feature_Ad == "true"
  );
  
  console.log("changeFlashLightFeature==>isHaveFlashLand", isHaveFlashLand);
  
  if (isHaveFlashLand.length > 0) {
    let getHaveFlashLand = isHaveFlashLand[0].graphic;
    console.log(
      "getHaveFlashLand.attributes.OBJECTID",
      getHaveFlashLand.attributes.OBJECTID
    );
    let deleteFeatures = [];
    deleteFeatures.push({ objectId: getHaveFlashLand.attributes.OBJECTID });
    
    return F_Land_parcels.applyEdits({
      deleteFeatures: deleteFeatures,
    });
  } else {
    console.log(
      "selectedFeature.attributes.CITYNAME_AR",
      selectedFeature?.attributes?.CITYNAME_AR
    );

    const attributes: any = {};
    attributes["Feature_Ad"] = featureFalsh;
    attributes["Parcel_Cod"] = `${selectedFeature?.attributes?.OBJECTID || ""}`;
    attributes["ZK"] =
      selectedFeature?.attributes?.CITYNAME_AR == null
        ? ""
        : selectedFeature?.attributes?.CITYNAME_AR;
    attributes["DK"] =
      selectedFeature?.attributes?.DISTRICTNAME_AR == null
        ? ""
        : selectedFeature?.attributes?.DISTRICTNAME_AR;
    attributes["NK"] =
      selectedFeature?.attributes?.DISTRICTNAME_AR == null
        ? ""
        : selectedFeature?.attributes?.DISTRICTNAME_AR;
    attributes["Land_Numbe"] =
      selectedFeature?.attributes?.SUBDIVISIONPARCELNUMBER == null
        ? ""
        : selectedFeature?.attributes?.SUBDIVISIONPARCELNUMBER;

    const addFeature = new Graphic({
      geometry: selectedFeature?.geometry && selectedFeature.geometry.type ? selectedFeature.geometry : null,
      attributes: attributes,
    });

    if (!addFeature.geometry) {
      console.warn("Invalid geometry for selectedFeature, cannot create graphic");
      return false;
    }

    return F_Land_parcels.applyEdits({ addFeatures: [addFeature] });
  }
};

/**
 * Deletes a point feature
 */
export const deletePoint = (objId: any, F_FavoriteLand: any) => {
  return F_FavoriteLand.applyEdits({
    deleteFeatures: [{ objectId: objId }],
  });
};
